<template>
  <b-form @submit.prevent="save">
    <b-row>
      <b-col md="6" >
        <b-form-group label="Ime i prezime *">
          <b-form-input v-model="userData.name" type="text"></b-form-input>
          <validation-description :show="$v.userData.name.$dirty && $v.userData.name.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Email *">
          <b-form-input v-model="userData.email"  type="text"></b-form-input>
          <validation-description :show="$v.userData.email.$dirty && $v.userData.email.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Rola *">
          <b-form-select v-model="userData.role.id">
            <option :value="null">-</option>
            <option :key="index" v-for="(role, index) in roles" :value="role.id">
              {{ role.name }}
            </option>
          </b-form-select>
          <validation-description :show="$v.userData.role.id.$dirty && $v.userData.role.id.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6" >
        <b-form-group label="Status *">
         <b-form-select :options="options_status" v-model="userData.is_active"></b-form-select>
        </b-form-group>
        <validation-description :show="$v.userData.is_active.$dirty && $v.userData.is_active.$invalid">
          {{$t('FIELD_MANDATORY')}}
        </validation-description>
      </b-col>
    </b-row>
    <template v-if="userData.role && userData.role.id === CLIENT_ROLE">
      <b-row >
        <hr/>
        <b-col cols="12">
          <h5>
            Klijenti
          </h5>
        </b-col>
        <b-col cols="12" v-if="userData.clients">
          <table class="table -no-padding">
            <tr  :key="`client_${client.id}`" v-for="(client, index) in userData.clients">
              <td style="width: 90%;">
                <SearchClient @input="chooseClient($event, index)" :value="userData.clients[index]" :disabled="disabledClientSearch(client)"></SearchClient>
                <small class="text-danger" v-if="clientValidationError && !disabledClientSearch(client)">
                  Polje je obavezno
                </small>
                <small class="text-danger" v-if="errorClientExist[index]">
                  Ovog klijenta ste vec dodali
                </small>

              </td>
              <td>
                <b-button class="btn btn-link btn-sm btn-del text-info" @click.prevent="deleteClient(index)">
                  <i class="fa fa-trash"></i>
                </b-button>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col cols="12">
          <button class="btn btn-link ml-0 pl-0" @click.prevent="addClient">Dodaj klijenta</button>
          <p>
            <validation-description :show="$v.userData.clients.$dirty && $v.userData.clients.$invalid">
              {{$t('FIELD_MANDATORY')}} za klijent rolu
            </validation-description>
          </p>
        </b-col>
      </b-row>
    </template>
    <b-row>
        <b-col>
          <app-button-submit :loading="loading_save" ></app-button-submit>
        </b-col>
        <b-col>
          <delete-button
                         @click="showDeleteDialog=true"
                         class="pull-right">
          </delete-button>

          <confirmation-dialog :show="showDeleteDialog" @confirm="deleteApp" @cancel="showDeleteDialog=false"> </confirmation-dialog>
        </b-col>
    </b-row>

  </b-form>
</template>

<script>
  import _findKey from 'lodash/findKey'
  import AppButtonSubmit from '@/components/app/AppSubmit'
  import ConfirmationDialog from '@/components/app/form/AppConfirmationDialog'
  import DeleteButton from '@/components/app/AppDelete'
  import {getRoleList} from "@/services/role"
  import {updateUser} from "@/services/user";
  import {toast} from "@/shared/plugins/toastr";
  import {getErrorMessage} from '@/mixins/error/getErrorMessage'
  import {required} from 'vuelidate/lib/validators'
  import ValidationDescription from '@/components/app/form/AppValidationDescription'
  import {deleteUser} from "@/services/user";
  import i18n from '@/locale/index'
  import AppButton from "@/components/app/AppButton";
  import SearchClient from "@/components/client/SearchClient";
  import {cloneDeep, isNumber} from "lodash";
  import {CLIENT_ROLE} from "@/shared/constants";

  export default {
    name: "user-edit-form",
    props:{
      id:{
        type:Number
      }
    },
    mixins:[getErrorMessage],
    data() {
      return {
        isNumber,
        showDeleteDialog:false,
        select: this.selected,
        editAsidePanel:'',
        options_status:[
          {value:null, text:'-'},
          {value:1, text: i18n.t('ACTIVE')},
          {value:0, text: i18n.t('NOTACTIVE')}
        ],
        userData:{
          id:null,
          name:null,
          email:null,
          password:null,
          role:{
            id:null,
          },
          is_active:null,
          clients:[]
        },
        roles:[],
        loadingReset:false,
        loading_save:false,
        clientValidationError: false,
        CLIENT_ROLE,
        errorClientExist: {}
      }
    },
    editAsidePanel: false,
    components:{
      SearchClient,
      AppButton,
      AppButtonSubmit,
      DeleteButton,
      ConfirmationDialog,
      ValidationDescription

    },
    computed:{
       userIndex(){
         if(!this.id){
           null
         }
         let userList =  this.$store.getters['user/getSearchList']
         let index = _findKey(userList, (el)=>{
           return el.id === this.id
         })
         return index
       },
       user(){
         return  this.$store.getters['user/getSearchList'][this.userIndex]
       },
      selectedClientIds(){
         if(this.userData.role && this.userData.role.id && this.userData.role.id === CLIENT_ROLE) {
            return this.userData.clients.filter((el)=> el.id).map((el)=> el.id);
         } else {
           return  []
         }
      }
    },
    validations() {
      return this.userData && this.userData.role && this.userData.role.id === CLIENT_ROLE
      ? {
          userData:{
            name:{required},
            email:{required},
            is_active:{required},
            role: {
              id:{required},
            },
            clients: {required}
          }
        }
        : {
          userData:{
            name:{required},
            email:{required},
            is_active:{required},
            role: {
              id:{required},
            },
          }
        }
    },
    methods:{
      chooseClient(value, index) {
        if(this.userData.clients.find((el) => el.id === value.id)) {
          this.$set(this.errorClientExist, index, true);
          return;
        }
        this.$set(this.errorClientExist, index, false);
        this.$set(this.userData.clients, index, value)
      },
      disabledClientSearch(client) {
        return client.id !== null;
      },
      save(){
        this.$v.userData.$touch()
        if(this.$v.userData.$invalid){
          toast({
            'title': this.$t('VALIDATION_FAILED'),
            'message': null,
            'type': 'error',
            'timeout': 4000
          })
          return
        }
        this.loading_save= true
        const request = {
          id: this.userData.id,
          name: this.userData.name,
          email: this.userData.email,
          is_active: this.userData.is_active,
          role: this.userData.role,
          clients: this.selectedClientIds
        }
          updateUser(this.userData.id, request)
            .then(()=>{
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_SUCCESS.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
                'type': 'success',
                'timeout': 2000
              })
                this.$store.dispatch('user/actionSearch')
                this.$emit('closePanel', this.editAsidePanel)

            }, error=>{
              toast({
                title: this.$t('NOTIFICATIONS.SAVE_ERROR.TITLE'),
                message: this.$t('NOTIFICATIONS.SAVE_ERROR.MESSAGE', {value: this.getMessages(error)}),
                'type': 'error',
                'timeout': 6000
              })
          }).finally(()=>{
            this.loading_save = false
          })
      },
      deleteApp(){
        deleteUser(this.userData.id)
          .then(response => {
              this.showDeleteDialog = false,
            toast({
              'title': this.$t('NOTIFICATIONS.DELETE_SUCCESS.MESSAGE'),
              'message': null,
              'type': 'success',
              'timeout': 2000
            })
            this.$store.dispatch('user/actionSearch')
            setTimeout(() => {
              this.$emit('closePanel', this.editAsidePanel)
            }, 500)

          },error => {
              toast({
                'title': "Delete  fail",
                'message': this.getMessages(error),
                'type': 'error',
                'timeout': 6000
              })
            })
      },
      getRoles() {
          let roleList = []
          getRoleList()
             .then(response => {
               roleList = response.data
               this.roles = roleList;
          })
      },
      addClient() {
        const invalidClient = this.userData.clients.find((client) => {return !client.name});
        if(invalidClient) {
          this.clientValidationError = true
        } else {
          this.clientValidationError = false;
          this.userData.clients.push({id:null, name: null});
        }

      },
      deleteClient(index) {
        this.userData.clients.splice(index, 1);
      }
    },

    created(){
      this.getRoles()
      this.userData = cloneDeep(this.user);
    }
  }
</script>

<style scoped>
.table.-no-padding td{
  padding-left: 0;
  padding-right: 0;
}
.btn-del{
  background: none;
  font-size: 18px;
  border: unset;
}
</style>
